import React, { useContext, useState, useRef, useEffect, useMemo } from 'react';
import styled from '@emotion/styled';
import { ID } from '@/src/hooks/types'

const AccordionContext = React.createContext<{
  fullHeight: number;
  panelHeight: number;
  activeID: ID;
  setActiveID: (id: ID) => void;
}>(undefined);

export const useAccordionContext = () => useContext(AccordionContext);

export interface AccordionProps extends AccordionState {
  children?: React.ReactChild | React.ReactChild[];
  defaultActive?: ID,
}

export interface AccordionState {
}
export function useAccordion(): AccordionState {
  return {} as AccordionState;
}

export function Accordion(props: AccordionProps) {
  const {
    children,
    defaultActive
  } = props;
  const {
    Container
  } = S;
  const [activeID, setActiveID] = useState<ID>(defaultActive);
  const [fullHeight, setFullHeight] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current.offsetHeight) {
      setFullHeight(containerRef.current.offsetHeight);
      const resize = () => setFullHeight(containerRef.current.offsetHeight);
      window.addEventListener("resize", resize);
      return () => window.removeEventListener('resize', resize);
    }
  }, [containerRef]);
  const panelHeight = useMemo(
    () => Array.isArray(children) ? fullHeight - 22 * children.length : fullHeight - 22,
    [fullHeight, children]
  )
  return (
    <AccordionContext.Provider value={{ activeID, fullHeight, panelHeight, setActiveID }}>
      <Container ref={containerRef}>
        {children}
      </Container>
    </AccordionContext.Provider>
  );
}
const S = {
  Container: styled.div`
    height: 100vh;
    background-color: #000;
    color: #fff;
  `,
}
